let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i8Yee")).then(() => parcelRequire('de33F'));